<div class="custom-header" [ngClass]="isDisabled() ? 'disabled': ''">
    <p-checkbox [binary]="true" [disabled]="isDisabled()" [ngModel]="checked()" (onChange)="onChange($event)" />
    <span style="margin: 3px;">{{ displayName() }}</span>
</div>